import RandingStyle26 from "../../randing/RandingStyle26";

function Randing473({ urlCode, urlCodeSettingId }) {
  const footerData = {
    line1: "의정부아이엠치과의원 | 대표 : 권오득 | 사업자등록번호 : 481-95-01368",
    line2: "경기도 의정부시 시민로80 센트럴타워 10층 아이엠치과의원  TEL. 1577-7371",
    line3: "COPYRIGHT© 의정부아이엠치과의원. ALL RIGHTS RESERVED"
  };

  const altTexts = {
    step1: "의정부 치아교정 고민중이세요? 클리피씨 치아교정 비용 혜택 진행상황 0% 치아교정을 정말 하고 싶다?",
    step2: "의정부 치아교정 고민중이세요? 클리피씨 치아교정 비용 혜택 진행상황 30% 교정이 필요한 이유? 돌출입 덧니 부정교합 기타",
    step3: "의정부 치아교정 고민중이세요? 클리피씨 치아교정 비용 혜택 진행상황 60% 1. 교정 치과 선택 시 고려대상은? 비용 위치 의사 경력 병원 크기",
    step4: "의정부 치아교정 고민중이세요? 클리피씨 치아교정 비용 혜택 진행상황 100% 1. 성함과 연락처를 입력해주세요 이름 연락처"
  };

  const optionLabels = {
    step1: {
      left: "O",
      right: "X"
    },
    step2: {
      left1: "돌출입",
      right1: "덧니",
      left2: "부정교합",
      right2: "기타"
    },
    step3: {
      left1: "비용",
      right1: "위치",
      left2: "의사경력",
      right2: "병원크기"
    }
  };

  return (
    <>
      <RandingStyle26
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        imageFolderPath={`${process.env.REACT_APP_CDN_BASE}/images/473`}
        keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/473/keepBtn.png`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/473/postBtn.png`}
        companyName="의정부아이엠치과의원"
        privacyCompanyName="의정부아이엠치과의원"
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        privacyNewForm={true}
        privacyTrustee="(주)퍼널스"
        privacySheet={true}
        customFooter={true}
        footerData={footerData}
        altTexts={altTexts}
        optionLabels={optionLabels}
      />
    </>
  );
}

export default Randing473;
